import { FC, memo, PropsWithChildren, useEffect, useState } from 'react'
import css from './index.module.less';

export const PrivacyAgreement: FC = memo(props => {

  return (
    <div className={css.Page}>
      <h3>隐私政策</h3>

      <p>发布日期： 2023年  4月 6日</p>


      <p>益世界网络科技(广东)有限公司（下称为“我们”）致力于保护您的隐私。本隐私政策(下称“本政策”)适用于益世界游戏服务中心（下称为“本中心”）如何收集、使用、存储、共享与保护个人信息，并规定了您对该信息所持有的相关选择和权利。</p>

      <p>如您通过本中心使用其他关联方运作的产品或服务，并欲了解相关数据如何被处理，请查阅该产品或服务的隐私政策。</p>

      <p>我们保留根据需要修改本政策的权利，例如，为符合法律、法规、内部规范和规程修改或监管机构要求而进行的修改，请您仔细阅读以下内容并保持关注更新。</p>

      <p>一、您的个人信息用于以下目的：</p>

      <p>- 实现本中心内的功能为多款游戏的玩家（您）提供客户服务，例如投诉、举报、建议、争议解决、处理账号、撤回授权。</p>
      <p>- 安全保障，我们会将您的信息用于实名认证、身份验证、风险监测、存档备份、保障他人使用本中心的安全性、防范非法或违规内容传播等用途。</p>
      <p>- 评估、改善我们的服务质量。</p>
      <p>- 遵守法律法规的相关规定、要求。</p>

      <p>二、个人信息的收集</p>

      <p>我们根据法律法规的要求，遵循合法、正当、必要和诚信的原则，仅收集实现第一项所列目的所必要的个人信息，包括：</p>

      <p>1.您主动提供的信息，例如：您主动提供的昵称、游戏ID、手机号码、邮箱、身份证件信息、图片、订单号码等，以及您接入客服后提供给我们的其他信息（包括但不限于语音、文字形式）。</p>
      <p>2.设备信息，例如：已安装应用信息、设备标识符、设备机型、操作系统及版本、客户端版本、设备唯一识别码（如IMEI/android ID/IDFA/OPENUDID/GUID/SIM 卡/IMSI 信息/ICCID）、设备码ID、设备名称、品牌、设备软硬件及系统版本、设备分辨率、设备序列号、移动终端存储内存、MAC地址、应用ID、网络类型、软硬件特征信息、设备屏幕尺寸、移动网络信息、日志信息、CPU信息、软件信息。</p>

      <p>三、个人信息的共享与转让</p>

      <p>我们会聘请第三方作为我们的服务提供商，代表我们执行某些任务，例如，1）验证您的登录行为是否具备风险；2）处理或储存与您使用我们的服务相关的数据。同时，我们会指示所聘请的服务提供商按照本隐私政策的规定处理您的信息。</p>

      <p>未经您的授权，我们不会向第三方转让您的个人信息。随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形并按照法律法规及符合本政策要求的标准继续保护或要求新的处理者继续保护您的个人信息。</p>

      <p>四、个人信息的披露</p>

      <p>在如下情况下，我们将依据法律的规定全部或部分的披露您的个人信息：</p>
      <p>1.涉及公共、我们或其他第三方合法权益的，需要向第三方或者行政、司法机构披露。</p>
      <p>2.如您出现涉嫌违反相关法律、法规或者我们服务协议或相关规则的情况，存在侵犯我们或任何第三方的合法权益时，需要向第三方或者行政、司法机构披露。</p>
      <p>3.我们根据法律、法规或者政策认为合适的其他披露。</p>
      <p>4.以下情形：</p>
      <p>·出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>·个人信息主体自行向社会公众公开个人信息的；</p>
      <p>·从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>

      <p>五、您的权利</p>

      <p>1.您有权利通过本中心的操作访问、查询、复制、更新、补充您的个人信息。</p>
      <p>2.您可联系我们要求删除您的全部或部分记录以及注销您的账号。为保护您的信息免遭意外或恶意破坏，当您要求我们删除您的信息以及注销您的账号时，我们会先通过相应审核流程确认您的身份，才会对您的请求采取行动。</p>
      <p>3.您有权通过设备权限设置的方式自主关闭权限以限缩本中心收集个人信息的范围，但可能会影响您使用本中心的功能或服务。</p>
      <p>4.您有权联系我们或通过设备权限设置撤回您先前同意我们收集、使用和处理您的个人信息的授权，但您该撤回授权的行为不影响撤回前基于您的同意的个人信息的收集、使用和处理。</p>

      <p>六、第三方SDK接入</p>

      <p>您在使用本中心时，为产品调研、数据分析、交易功能、咨询推送功能实现及优化服务，我们会接入第三方SDK，其目的及信息收集类型如下：</p>

      <p>1.SDK名称:数数SDK</p>
      <p>包名：cn.thinkingdata.android</p>
      <p>使用场景：分析用户产品使用和表现情况，用于提供和改进服务</p>
      <p>信息收集类型：运行中的进程、Android ID、个人身份信息（包括但不限于您的姓名，电话号码和邮政地址）、日志信息（包括浏览器版本，您访问的服务页面，访问的时间和日期）、Cookies（被用作匿名唯一标识符）</p>
      <p>第三方主体：数数信息科技（上海）有限公司</p>
      <p>隐私政策：http://doc.thinkingdata.cn/ta-manual/latest/</p>

      <p>2.SDK名称：微信open SDK</p>
      <p>包名：com.tencent.mm.open</p>
      <p>使用场景：用于微信账号登录服务、帮助用户分享内容至微信客户端</p>
      <p>信息收集类型：设备型号、操作系统版本、设备及应用信息、移动网络信息、日志信息、国际移动设备标识码（IMEI）、MAC地址</p>
      <p>第三方主体：深圳市腾讯计算机系统有限公司</p>
      <p>隐私政策：</p>
      <p>https://privacy.qq.com/document/preview/bdf936b2477a45ff86da57e3d988bc2b</p>

      <p>3.SDK名称：MSA移动安全联盟SDK</p>
      <p>包名：com.bun.miitmdid</p>
      <p>信息收集类型：设备信息(UDID、OAID、VAID、AAID)</p>
      <p>使用场景：启动时获取移动联盟厂商的统一的补充设备标识</p>
      <p>第三方主体：中国信息通信研究院</p>
      <p>隐私政策：http://www.msa-alliance.cn</p>

      <p>八、未成年人信息保护</p>

      <p>我们非常重视对未成年人信息的保护。</p>
      <p>若您是未成年人，在使用本中心之前，应事先取得您父母或法定监护人同意。</p>
      <p>若您是未成年人的监护人，当您在帮助未成年人完成产品或服务的注册、使用前，应当仔细阅读本政策，在同意本政策后帮助未成年人进行注册、使用，以便未成年人能使用本中心。</p>
      <p>不满十四周岁的未成年人适用《儿童隐私保护政策》，请相关监护人前往详阅。</p>

      <p>九、您的个人信息安全</p>

      <p>1.我们实施安全措施以确定注册用户的身份，以便为用户提供适当的权利和限制，您要负责维护登录凭证的安全性。</p>
      <p>2.我们建立专门的管理制度、流程以确保您的信息安全，并传达、要求我们内部全体员工严格执行本隐私政策。</p>
      <p>3.您的信息会通过合理的安全措施存储中华人民共和国境内服务器。一般情况下，我们只会在为实现第一项所列目的所必需的时间内存储您的个人信息。前述期限届满后，我们将对您的个人信息做删除或匿名化处理，但下列情况除外：</p>
      <p>·为遵守法院判决、裁定或其他法律程序的规定；</p>
      <p>·为遵守相关政府机关执法的要求；</p>
      <p>·为应对您的投诉、举报等相关请求；</p>
      <p>·为应对与您相关的司法程序。</p>
      <p>4.尽管我们努力实施适当的安全措施，但使用网络存在固有风险，我们无法保证零风险。</p>

      <p>十、提示条款</p>

      <p>若因您未提供完整且确实个人资料，造成对您及第三人发生损害时，您应负担一切责任；如因不实资料发生争议致使我们的利益受损时，我们将视状况而进行法律追诉。</p>
      <p>我们可能会适时修订本政策，但我们会即时予以更新发布，请您保持关注查看。在该种情况下，若您继续使用本中心，即表示同意受经修订的本政策的约束。</p>
      <p>您可能向我们提供他人的信息，您有责任告知他人，将为上述目的处理他人的个人信息，并确认他人已获知本政策。</p>
      <p>本政策仅针对我们控制的个人信息。您可能会通过第三方提交您的信息，他们会根据自身的独立隐私政策处理您的个人信息，我们对该等第三方如何处理您的个人信息概不负责。</p>

      <p>十一、纠纷适用法律及处理方式</p>

      <p>除按相关法律有特别约定外，本政策受中华人民共和国的法律（不包含港澳台地区的法律）约束。本服务的实际提供地为广州市天河区，若因本政策的订立、生效、履行等，我们与您发生争议的，您同意相应争议、纠纷均由广州市天河区人民法院管辖。</p>

      <p>十二、联系方式</p>

      <p>请通过以下方式或本中心联系我们，我们预计会在收到您的请求后15个工作日内回复您：</p>
      <p>联系方式：kefu@eworld.cn</p>


      <h3>儿童隐私保护政策</h3>

      <p>益世界网络科技(广东)有限公司（下称为“我们”）高度重视和尊重儿童的个人信息保护。您作为未成年人的监护人（本政策特指未满十四周岁的未成年人，下称“儿童”或“您的孩子”），在您的孩子使用益世界游戏服务中心（下称为“本中心”）时，我们可能会收集相关的个人信息。您的孩子在享受我们的服务前，请您务必与您的孩子一同仔细阅读本隐私政策相关内容，了解并理解我们对您的信息的收集、使用、存储、共享以及您及您的孩子所享有的相关权利。</p>

      <p>【重要提示】</p>

      <p>本政策适用于不满十四周岁的未成年人的个人信息处理，对于已满十四周岁的用户的个人信息，请您查看我们《隐私政策》的相关规定。</p>

      <p>本隐私政策将帮助您了解以下内容：</p>

      <p>一、我们如何收集及使用儿童个人信息；</p>

      <p>二、我们如何共享、公开披露儿童的个人信息；</p>

      <p>三、我们对儿童个人信息的存储、存储期限及安全保护；</p>

      <p>四、儿童个人信息更正、删除、管理、撤回授权等权利；</p>

      <p>五、本政策修订更新；</p>

      <p>六、纠纷适用法律及处理方式；</p>

      <p>七、投诉及建议</p>

      <p>一、我们如何收集及使用儿童个人信息</p>

      <p>1. 在儿童使用我们的服务时，以及我们为了更好的为儿童提供服务，优化服务内容、进行产品分析、产品安全目的等，会收集处理儿童的个人信息，包括但不限于儿童的姓名、身份证号、手机号、设备机型、操作系统及版本、客户端版本、设备设置、设备标识符、软硬件特征信息、设备传感器、设备ID、应用ID、浏览记录、访问登录记录日志、交互日志、交易记录等信息。</p>

      <p>2. 上述具体相关信息及使用目的、范围以及其他可能收集的信息等，请您及您的孩子查看我们《隐私政策》的相关规定。如我们需要超出上述范围收集和使用儿童个人信息的，我们会在征得监护人的同意后进行收集和使用。</p>

      <p>3. 根据相关法律法规规定，因以下目的，无需获得您的授权而收集的儿童的个人信息：</p>

      <p>3.1出于为国家安全、国防安全等国家利益需要的；</p>

      <p>3.2为公共安全、公共卫生等重大公共利益目的相关的；</p>

      <p>3.3出于为犯罪侦查、起诉、审判和判决执行等需求目的相关的；</p>

      <p>3.4出于维护儿童或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</p>

      <p>3.5儿童本人已自行向社会公众公开的；</p>

      <p>3.6根据要求签订和履行合同所必需的；</p>

      <p>3.7从合法公开披露或第三方合法授权获得的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道或为开展相应新闻报道必需的；</p>

      <p>3.8为维护儿童所使用的产品或服务的安全稳定运行所必需的，例如发现、处理故障；</p>

      <p>3.9出于公共利益统计或学术研究所必要，但我们会尽量对结果中所包含的个人信息进行去标识化处理的；</p>

      <p>3.10法律法规规定的其他情形。</p>

      <p>二、我们如何共享、公开披露儿童的个人信息</p>

      <p>1.未征得您的同意，我们不会将儿童的信息提供、共享给任何第三方或出售、出租、交易您的个人信息，但根据我国相关法律规定需对外分享、披露的除外，比如根据本政策第二.2条的约定，我们可以合法的对外分享、披露您的信息。</p>

      <p>2.在如下情况下，我们将依据您的个人意愿或法律的规定全部或部分的披露儿童的个人信息：</p>

      <p>2.1经您事先同意，向第三方披露。</p>

      <p>2.2根据法律的有关规定，或者行政或司法机构的要求，涉及公共、我们或其他第三方合法权益的，我们可能需要向第三方或者行政、司法机构披露。</p>

      <p>2.3如儿童出现违反相关法律、法规或者我们服务协议或相关规则的情况（如存在不当言行、反动、暴力、色情等行为时），存在侵犯我们或任何第三方的合法权益时，需要向第三方或者行政、司法机构披露。</p>

      <p>2.4如儿童是适格的知识产权投诉人或被投诉人并已或被提起投诉，应投诉人或被投诉人的要求，向投诉人或被投诉人披露，以便双方处理可能的权利纠纷。</p>

      <p>2.5其它我们根据法律、法规或者政策认为合适的披露。</p>

      <p>3.您在使用本中心时，为实现产品功能及优化服务，我们会接入第三方SDK，其目的及信息收集类型如下：</p>

      <p>1.SDK名称:数数SDK</p>
      <p>包名：cn.thinkingdata.android</p>
      <p>使用场景：分析用户产品使用和表现情况，用于提供和改进服务</p>
      <p>信息收集类型：运行中的进程、Android ID、个人身份信息（包括但不限于您的姓名，电话号码和邮政地址）、日志信息（包括浏览器版本，您访问的服务页面，访问的时间和日期）、Cookies（被用作匿名唯一标识符）</p>
      <p>第三方主体：数数信息科技（上海）有限公司</p>
      <p>隐私政策：http://doc.thinkingdata.cn/ta-manual/latest/</p>

      <p>2.SDK名称：微信open SDK</p>
      <p>包名：com.tencent.mm.open</p>
      <p>使用场景：用于微信账号登录服务、帮助用户分享内容至微信客户端</p>
      <p>信息收集类型：设备型号、操作系统版本、设备及应用信息、移动网络信息、日志信息、国际移动设备标识码（IMEI）、MAC地址</p>
      <p>第三方主体：深圳市腾讯计算机系统有限公司</p>
      <p>隐私政策：</p>
      <p>https://privacy.qq.com/document/preview/bdf936b2477a45ff86da57e3d988bc2b</p>

      <p>3.SDK名称：MSA移动安全联盟SDK</p>
      <p>包名：com.bun.miitmdid</p>
      <p>信息收集类型：设备信息(UDID、OAID、VAID、AAID)</p>
      <p>使用场景：启动时获取移动联盟厂商的统一的补充设备标识</p>
      <p>第三方主体：中国信息通信研究院</p>
      <p>隐私政策：http://www.msa-alliance.cn</p>

      <p>三、我们对儿童个人信息的存储、存储期限及安全保护</p>

      <p>1. 我们会遵守法律法规的规定，按现有的安全保障技术水平，将儿童的个人信息存储现有技术安全保障的中国境内的服务器中。</p>

      <p>2. 儿童的个人信息保存期限为儿童使用我们网络服务的必要期限内直至儿童按本政策约定权利或相关法律规定要求我们删除或处理儿童的信息，超过上述个人信息保存期限后或在我们收到您及您的孩子的请求，并对您及您孩子的身份核实后，我们会对儿童的个人信息进行删除或匿名化处理或按您或您孩子的请求处理。</p>

      <p>3. 我们会为儿童的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露，但您理解并确认，我们仅能根据现有的安全保障技术水平提供最大限度的安全保障义务，我们无法保证为儿童提供的安全保障措施为百分百安全无漏洞、无风险的保障措施，因此，您在选择我们的服务时即已清晰知晓可能存在的安全风险。</p>

      <p>4. 我们将尽我们最大的努力为儿童的个人信息提供安全保护，亦请您及您的孩子妥善保管账户及密码信息等。我们将通过对用户密码进行加密等安全措施确保儿童的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意及理解在信息网络上不存在“完善的安全措施”。</p>

      <p>5. 在使用我们网络服务进行网上交易时，请您及您的孩子妥善保护自己的个人信息，非本人亲自同意及在必要的情形下，请勿向他人提供。如您发现儿童的个人信息泄密，请您立即联络我们，以便我们采取相应措施。</p>

      <p>四、儿童个人信息更正、删除、管理、撤回授权等权利</p>

      <p>1. 访问、更正权。您有权利访问查询、修改更正您的孩子个人信息的情况，对于您孩子的注册信息，若您需要更正修改的，比如头像、昵称、性别等身份信息，您可以直接操作我们的产品或服务进行修改或请您及时与我们联系，并将相应情况反馈给我们，我们将协助您进行修改。</p>

      <p>2. 删除权。您若认为我们已不再需要您孩子个人信息的或存在不当处理的，您有权要求我们对我们持有、使用、处理您的相关个人信息进行删除。但若该个人信息涉及按相关法律法规为保护我们的合法权益或任何第三方或公共利益时，我们会暂时予以保留，并将情况告知您，在不再需要时，会将儿童个人信息进行删除或匿名化处理。</p>

      <p>且您知悉理解，若您要求删除的信息涉及为网络服务的基础账户信息或相关功能服务所需信息，您删除的请求可能会影响儿童使用我们提供的网络服务内容。</p>

      <p>3.撤回权。您有权随时撤回您先前同意我们收集、使用和处理儿童个人信息的授权，但您该撤回授权的行为将不影响撤回前基于您的同意的个人信息的收集、使用和处理。</p>

      <p>4. 注销账户及其他权利。您可以随时注销您孩子的账户，若您需要注销账户的，请您或您孩子联系我们的客服。对于根据法律规定，您及您的孩子享有的其他权利，您及您的孩子可以跟我们联系，我们会按照规定处理。</p>

      <p>5. 若您及您的孩子需进行以上相关权利的操作，请根据上述约定在我们的服务设置中进行相关的操作或向我们提起书面请求，我们在确认您及您的孩子的请求要求及核对您及您孩子的身份后，将在提出请求后的15个工作日内回复您及您的孩子，并进行上述操作。</p>

      <p>6. 为保障安全，您及您的孩子可能需要提供书面请求。如果我们有合理依据认为上述请求存在欺骗性、无法实行或损害他人隐私权，我们有权拒绝处理请求。</p>

      <p>五、本政策修订更新</p>

      <p>1. 我们变更收集、使用信息内容、使用授权范围等，我们均会通过您及您孩子提供的个人联系方式通知您及您的孩子，若无法完全通过您及您孩子的联系方式通知的，我们会在游戏内、官网等渠道、平台进行变更公告、通知，或另行获得您的明确授权。</p>

      <p>2. 我们可能会适时修订本隐私政策，但我们会即时予以更新发布。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本隐私政策的约束。</p>

      <p>六、纠纷适用法律及处理方式</p>

      <p>除按相关法律有特别约定外，本政策受中华人民共和国的法律约束。若因本政策的订立、生效、履行等，我们与您孩子发生争议的，您同意相应争议、纠纷由本中心服务实际提供地（广州市天河区）有管辖权的人民法院管辖。</p>

      <p>七、投诉及建议</p>

      <p>如果您需行使本政策相关权利或对本政策或相关事宜有任何问题举报或投诉、与账号有关等问题，可以通过以下方式或产品客服联系我们，我们会在收到您的请求后15个工作日内回复您。</p>

      <p>联系邮箱：kefu@eworld.cn</p>



    </div>
  )
})
